// eslint-disable-next-line no-unused-vars
import { useTranslation, withTranslation } from "react-i18next";
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Header from '../Components/Header/Header';
import { setAdminMode as setIsOpen } from 'store/slices/businessSlice';
import './Landing.css';

class Landing extends PureComponent {
  componentDidMount() {
    this.props.setIsOpen(false);
    document.body.classList.add('index-page');
  }

  componentWillUnmount() {
    document.body.classList.remove('index-page');
  }

  render() {
    const { t } = this.props;
    return <div className="landing-page-wrapper">
        <Header />
        <Helmet>
          <title>{t("HeresMyInfo - Contact Sharing")}</title>
        </Helmet>

        <style>{`
          .btn-pill-primary {
            background: linear-gradient(135deg, #0052ff 0%, #00d2ff 100%);
            color: #ffffff;
            font-weight: 600;
            font-size: 0.82rem;
            padding: 8px 16px;
            border-radius: 50px;
            border: none;
            display: inline-flex;
            align-items: center;
            gap: 8px;
            transition: all 0.3s ease;
            box-shadow: 0 4px 15px rgba(0, 82, 255, 0.4);
            text-decoration: none;
          }

          .btn-pill-primary:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(0, 82, 255, 0.6);
            color: #ffffff;
            text-decoration: none;
          }

          .btn-pill-secondary {
            background: rgba(255, 255, 255, 0.05);
            border: 1px solid rgba(255, 255, 255, 0.15);
            color: #ffffff;
            font-weight: 600;
            font-size: 0.82rem;
            padding: 8px 16px;
            border-radius: 50px;
            display: inline-flex;
            align-items: center;
            gap: 8px;
            transition: all 0.3s ease;
            backdrop-filter: blur(10px);
            text-decoration: none;
          }

          .btn-pill-secondary:hover {
            background: rgba(255, 255, 255, 0.1);
            border-color: rgba(255, 255, 255, 0.25);
            color: #ffffff;
            text-decoration: none;
          }

          @media (max-width: 767px) {
            .features-section {
              display: none !important;
            }
            .hero-subtitle {
              display: none !important;
            }
            .btn-pill-secondary {
              display: none !important;
            }
            .glass-label {
              display: none !important;
            }
            .landing-hero {
              flex-direction: column !important;
              align-items: center !important;
              padding: 85px 20px 20px 20px !important;
              text-align: center !important;
              gap: 20px !important;
              flex-shrink: 0 !important;
            }
            .hero-left {
              max-width: 100% !important;
              margin-top: 0 !important;
              margin-bottom: 20px !important;
            }
            .hero-title {
              font-size: 1.25rem !important;
              margin-bottom: 10px !important;
              line-height: 1.25 !important;
            }
            .hero-title .title-white-smaller {
              font-size: 0.8em !important;
            }
            .hero-title .title-accent {
              font-size: 0.95em !important;
            }
            .hero-actions {
              justify-content: center !important;
              margin-top: 12px !important;
              width: 100% !important;
            }
            .btn-pill-primary {
              width: 100% !important;
              max-width: 220px !important;
              justify-content: center !important;
              font-size: 0.72rem !important;
              padding: 8px 14px !important;
            }
            .hero-signin-prompt {
              text-align: center !important;
              margin-top: 14px !important;
              font-size: 0.8rem !important;
              width: 100% !important;
            }
            .hero-right {
              flex: none !important;
              height: 250px !important;
              max-width: 100% !important;
              margin-top: 10px !important;
              position: relative !important;
              display: flex !important;
              justify-content: center !important;
              align-items: center !important;
            }
            .floating-shield {
              width: 130px !important;
              height: 130px !important;
              top: 30px !important;
            }
            .pedestal-wrapper {
              width: 180px !important;
              height: 60px !important;
            }
            .pedestal-base {
              width: 150px !important;
              height: 20px !important;
            }
            .pedestal-glow {
              width: 130px !important;
              height: 180px !important;
              bottom: 10px !important;
            }
            .landing-footer {
              padding: 45px 20px 20px 20px !important;
              margin-top: auto !important;
            }
          }
        `}</style>

        <div className="landing-hero">
          <div className="hero-left">
            <h1 className="hero-title">
              <span className="title-white-smaller">{t("Share & Control")}</span>
              <span className="title-white-smaller">{t("your information.")}</span>
              <span className="title-accent">{t("HeresMyInfo makes it easy.")}</span>
            </h1>
            <p className="hero-subtitle">{t("HeresMyInfo helps you securely share only what's needed with the right people\u2014so you stay in control and protected.")}</p>
            <div className="hero-actions">
              <Link to="/signup" className="btn-pill-primary">{t("Get Started Free")}<span style={{
                marginLeft: '4px'
              }}>→</span>
              </Link>
              <Link to="/learn" className="btn-pill-secondary">{t("See How It Works")}<span style={{
                marginLeft: '4px'
              }}>▶</span>
              </Link>
            </div>
            <div className="hero-signin-prompt">{t("Have an account?")}<Link to="/login">{t("Sign In")}</Link>
            </div>
          </div>

          <div className="hero-right">
            <div className="pedestal-wrapper">
              <div className="pedestal-glow" />
              <div className="pedestal-base" />
            </div>

            <img src={require('../assets/hmi_shield_logo.png')} alt={t("HeresMyInfo Logo")} className="floating-shield" />

            {
            /* Floating Glassmorphic Labels */
          }
            <div className="glass-label label-name">
              {/* eslint-disable-next-line jsx-a11y/accessible-emoji */}
              <span className="glass-label-icon">👤</span>
              <div className="glass-label-text">
                <div className="glass-label-title">{t("Name")}</div>
                <div className="glass-label-val">{t("Name")}<span className="glass-label-badge">✓</span></div>
              </div>
            </div>

            <div className="glass-label label-phone">
              {/* eslint-disable-next-line jsx-a11y/accessible-emoji */}
              <span className="glass-label-icon">📞</span>
              <div className="glass-label-text">
                <div className="glass-label-title">{t("Phone")}</div>
                <div className="glass-label-val">(555) 123-4567 <span className="glass-label-badge">✓</span></div>
              </div>
            </div>

            <div className="glass-label label-email">
              {/* eslint-disable-next-line jsx-a11y/accessible-emoji */}
              <span className="glass-label-icon">✉️</span>
              <div className="glass-label-text">
                <div className="glass-label-title">{t("Email")}</div>
                <div className="glass-label-val">{t("you@email.com")}<span className="glass-label-badge">✓</span></div>
              </div>
            </div>

            <div className="glass-label label-address">
              {/* eslint-disable-next-line jsx-a11y/accessible-emoji */}
              <span className="glass-label-icon">📍</span>
              <div className="glass-label-text">
                <div className="glass-label-title">{t("Address")}</div>
                <div className="glass-label-val" style={{
                color: '#00f0ff',
                fontSize: '0.8rem'
              }}>{t("Only shared when you choose \uD83D\uDD12")}</div>
              </div>
            </div>

            <div className="glass-label label-company">
              {/* eslint-disable-next-line jsx-a11y/accessible-emoji */}
              <span className="glass-label-icon">🏢</span>
              <div className="glass-label-text">
                <div className="glass-label-title">{t("Company")}</div>
                <div className="glass-label-val" style={{
                color: '#00f0ff',
                fontSize: '0.8rem'
              }}>{t("Only shared when you choose \uD83D\uDD12")}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="features-section">
          <div className="features-grid">
            <div className="feature-card">
              {/* eslint-disable-next-line jsx-a11y/accessible-emoji */}
              <div className="feature-icon-wrapper">🛡️</div>
              <h3 className="feature-title">{t("You're in Control")}</h3>
              <p className="feature-description">{t("Decide what information to share and who can see it.")}</p>
            </div>
            <div className="feature-card">
              {/* eslint-disable-next-line jsx-a11y/accessible-emoji */}
              <div className="feature-icon-wrapper">🔒</div>
              <h3 className="feature-title">{t("Stronger Security")}</h3>
              <p className="feature-description">{t("Keep your information safe with privacy-first technology.")}</p>
            </div>
            <div className="feature-card">
              {/* eslint-disable-next-line jsx-a11y/accessible-emoji */}
              <div className="feature-icon-wrapper">🚀</div>
              <h3 className="feature-title">{t("Easy to Share")}</h3>
              <p className="feature-description">{t("Share your info in seconds\u2014no typing, no hassle.")}</p>
            </div>
            <div className="feature-card">
              {/* eslint-disable-next-line jsx-a11y/accessible-emoji */}
              <div className="feature-icon-wrapper">👥</div>
              <h3 className="feature-title">{t("Granular Access")}</h3>
              <p className="feature-description">{t("Choose exactly who has what, and for how long.")}</p>
            </div>
          </div>
        </div>

        <footer className="landing-footer">
          <div className="footer-links">
            <Link to="/terms">{t("Terms of Service")}</Link>
            <Link to="/privacy">{t("Privacy Policy")}</Link>
          </div>
          <div className="footer-copyright">{t("All rights reserved, HMIAuth, LLC. 2026")}</div>
        </footer>
      </div>;
  }

}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
});

const mapDispatchToProps = dispatch => ({
  setIsOpen: () => dispatch(setIsOpen(false))
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Landing));